<ngx-json-ld [json]="schemaOrgData" *ngIf="schemaOrgData"></ngx-json-ld>

<!-- 標題 & 麵包屑 -->
<div class="row header" #pageHeader>
  <div class="bs-slider-overlay"></div>
  <div class="col-lg-10 col-lg-offset-1 col-md-12">
    <ol class="breadcrumb">
      <li><a [routerLink]="toHomePath">{{'home' | translate}}</a> </li>
      <li><a [routerLink]="toHomePath + '/' + 'datasearch'" queryParamsHandling="merge" [queryParams]="{indexCode: null, id: null, recOffset: null, searchWithKeywordTimeStamp: null}">搜尋</a> </li>
      <li class="active">{{data?.title}}</li>
    </ol>
    <h2 class="page-header-b">{{data?.title}}</h2>
  </div>
</div>
<!-- /.標題 & 麵包屑 -->

<ng-container *ngIf="data">
  <!-- 區塊:1 圖和下載等說明and基本資訊-->
  <section class="row clearfix">
    <div class="col-lg-10 col-lg-offset-1 col-md-12">
      <div class="search_01">
        <ng-container *ngIf="data.iframeUrl; else imageTmp">
          <div class="thumbnail" [class.d-none]="isShow3DFiles">
            <div class="image-wrap">
              <div class="embed-responsive embed-responsive-16by9">
                <div class="embed-responsive-item" #containerRef>
                  <ng-container *ngIf="data.iframeUrl.endsWith('.m3u8'); else commonVideoTmp">
                    <iframe
                    title="{{data.title}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                    [src]="$any(('/assets/hls-video-player?url=' + (data.iframeUrl | base64) + '&width=' + containerRef.offsetWidth + '&height=' + containerRef.offsetHeight) | safe: 'resource')"
                    [width]="containerRef.offsetWidth" [height]="containerRef.offsetHeight"
                    frameborder="0" allowfullscreen scrolling="no"
                    ></iframe>
                  </ng-container>
                  <ng-template #commonVideoTmp>
                    <iframe
                    [src]="$any(data.iframeUrl | safe: 'resource')" title="{{data.title}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                    width="100%" height="auto" frameborder="0" allowfullscreen scrolling="no"></iframe>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #imageTmp>
          <div class="swiper" [class.d-none]="isShow3DFiles" [tmSwiper]="imgswiperConfig" [ariaLabel]="''" *ngIf="data.images && data.images.length" #imageSwiper="tmSwiper">
            <div class="swiper-button-prev" role="button"
            (click)="imageSwiper.slidePrev()" (keydown.enter)="imageSwiper.slidePrev()"
            [class.swiper-button-disabled]="imageSwiper.activeIndex === 0 || data.images.length <= 1"
            [attr.aria-disabled]="imageSwiper.activeIndex === 0 || data.images.length <= 1"
            [attr.aria-label]="'swiper.prevSlideMessage' | translate"
            [tabindex]="imageSwiper.activeIndex === 0 || data.images.length <= 1 ? -1 : 0"
            ></div>
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-slide-1" *ngFor="let image of data.images; index as i">
                <div class="thumbnail">
                  <div class="image-wrap">
                    <img src="{{image.url}}" alt="{{data.images.length > 1 ? (i === 0 ? ('detailPage.relateImagesWithTitle1' | translate: {title: data.title, count: data.images.length}) : ('detailPage.relateImagesWithTitle' | translate: {title: data.title, index: i})) : data.title}}"
                    [style.opacity]="isBrowser ? 1 : 0"
                    width="{{image.width || (imgRef && imgRef.naturalWidth) || 'auto'}}" height="{{image.height || (imgRef && imgRef.naturalHeight) || 'auto'}}"
                    [tmObjectFit]="imgRef && (imgRef.naturalWidth <= 300 || imgRef.naturalHeight <= 300) ? 'scale-down' : 'contain'" imgSrc="{{image.url}}"
                    tmErrorDefaultImage="/assets/images/no-pic.webp"
                    #imgRef>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-button-next" role="button"
            (click)="imageSwiper.slideNext()" (keydown.enter)="imageSwiper.slideNext()"
            [class.swiper-button-disabled]="imageSwiper.activeIndex === data.images.length - imageSwiper.viewItemCount || data.images.length <= 1"
            [attr.aria-disabled]="imageSwiper.activeIndex === data.images.length - imageSwiper.viewItemCount || data.images.length <= 1"
            [attr.aria-label]="'swiper.nextSlideMessage' | translate"
            [tabindex]="imageSwiper.activeIndex === data.images.length - imageSwiper.viewItemCount || data.images.length <= 1 ? -1 : 0"
            ></div>
          </div>
        </ng-template>
        <ng-container *ngIf="data['threeDFiles'] && data['threeDFiles']['length'] && isShow3DFiles">
          <ng-container *ngFor="let item of data['threeDFiles']">
            <ng-container *ngIf="item.ext != 'mov'">
              <div *ngIf="isBrowser">
                <three-view [fileTemp]="item"></three-view>
              </div>
            </ng-container>
            <ng-container *ngIf="item.ext == 'mov'">
              <video id="movie" preload controls loop autoplay width="100%" height="auto">
                <source [src]="item.original | safe: 'resource'" type="video/mp4"/>
              </video>
            </ng-container>
          </ng-container>
        </ng-container>

        <div class="row cc_dl mt-2">
          <ng-container *ngIf="data['threeDFiles'] && data['threeDFiles'].length && (data.iframeUrl || (data.images && data.images.length))">
            <a href="javascript:void(0)" (click)="toggle3DFiles()" title="{{data['threeDFiles'][0]['ext'] === 'mov' ? '相關影音' : '3D檔案'}}" *ngIf="!isShow3DFiles">
              <img src="/assets/images/v040/3d-view.webp" class="cc_dl_img" alt="">
            </a>
            <a href="javascript:void(0)" class="threeD-mode-btn--actived" (click)="toggle3DFiles()" title="{{data.iframeUrl ? '切換回影片' : '切換回圖片'}}" *ngIf="isShow3DFiles">
              <img src="/assets/images/v040/3d-view.webp" class="cc_dl_img" alt="">
            </a>
          </ng-container>
          <ng-container *ngIf="data.downloadImages && data.imageLic">
            <ng-container *ngIf="data.imageLic === '僅限公開瀏覽'">
              <a href="javascript:void(0)" tabIndex="-1" role="button" title="{{'detailPage.dataAuthWithViewOnlynoDownload' | translate}}" style="cursor: default;" aria-disabled="true">
                <img src="/assets/images/v040/ico-download-no.webp" class="cc_dl_img" alt="{{'nodownload' | translate}}"
                width="28" height="35">
              </a>
            </ng-container>
            <ng-container *ngIf="data.imageLic !== '僅限公開瀏覽'">
              <a href="javascript:void(0)" tabIndex="0" role="button" title="{{'detailPage.downloadBigImage' | translate}}[{{'openNewWindow' | translate}}]" (click)="openOpenedCollectionGallery($event)">
                <img src="/assets/images/v040/ico-download.webp" class="cc_dl_img" alt="{{'download' | translate}}"
                width="32" height="31">
              </a>
              <ul class="list-unstyled row" tmPhotoSwipe [potoswipeSlides]="openReuseGalleryImages" hidden #openReuseGallery>
                <li *ngFor="let image of openReuseGalleryImages; let i = index">
                  <figure [attr.data-item]="i" [hidden]="i > 4">
                    <a href="{{ image.msrc }}">
                      <img src="{{ image.src }}" alt="{{ image.title }}" title="{{ image.title }}" tmErrorDefaultImage="/assets/images/no-pic.webp" hidden/>
                    </a>
                  </figure>
                </li>
              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="(data.images || data.iframeUrl) && data.imageLic">
            <a [appAuthLicense]="data.imageLic" #authLicRef="appAuthLicense" [href]="authLicRef.url || ('javascript:void(0)' | safe:'url')" [tabIndex]="authLicRef.url ? 0 : -1"
            attr.role="{{authLicRef.url ? 'link' : 'button'}}"  title="{{'detailPage.fieldLabel.imageLic' | translate}}: {{data.imageLic}}{{authLicRef.url ? ('[' + 'openNewWindow' | translate) + ']' : ''}}" [target]="authLicRef.url ? '_blank' : ''"
            [style.cursor]="authLicRef.url ? '' : 'default'"
            attr.aria-disabled="{{!authLicRef.url}}">
              <img src="{{authLicRef.image || ''}}" class="cc_dl_img" alt="{{'detailPage.fieldLabel.imageLic' | translate}}: {{data.imageLic}}"
              width="{{authLicRef.imageWidth}}" height="{{authLicRef.imageHeight}}">
            </a>
          </ng-container>
        </div>

        <div class="iamhr"></div>

        <div class="row">
          <div class="col-sm-6 col-md-6">
            <h2>{{data.title}}</h2>
          </div>

          <div class="col-sm-6 col-md-6">
            <div class="sharetools text-right">
              <ul>
                <a href="javascript:void(0)" role="button" style="cursor: default;" aria-disabled="true" title="{{'visitCount' | translate}}">
                  <li class="share">
                    <img src="/assets/images/v040/see_watch.svg" class="visiticon" alt="{{'visitCount' | translate}}" width="55" height="15">
                    <span class="sharew">{{data.viewCount || 0}}</span>
                  </li>
                </a>
                <theme-collect-btn selectTmp="linkTmp" type="collection" [materialId]="materialId" [fetchIndex]="fetchIndexCode"></theme-collect-btn>
                <a href="javascript:void(0)" role="button" (click)="shareToolModal.open()" title="{{'share' | translate}}">
                  <li class="share">
                    <img src="/assets/images/v040/share.svg" class="shareicon" alt="" width="55" height="20">
                    <span class="sharew">{{'share' | translate}}</span>
                  </li>
                </a>
                <a href="javascript:void(0)" role="button" (click)="friendlyPrint($event)" title="{{'print' | translate}}">
                  <li class="share">
                    <img src="/assets/images/v040/print.svg" class="shareicon" alt="" width="55" height="20">
                    <span class="sharew">{{'print' | translate}}</span>
                  </li>
                </a>
                <a href="javascript:void(0)" role="button" appOpenErrorReport title="{{'reportError' | translate}}"
                  [path]="fetchIndexCode" [uuid]="materialId" [sourceUrl]="sourceUrl" [sourceTitle]="data.title" [sourceOrg]="data.sourceName">
                  <li class="share">
                    <img src="/assets/images/v040/message.svg" class="shareicon" alt="" width="55" height="20">
                    <span class="sharew">{{'reportError' | translate}}</span>
                  </li>
                </a>
              </ul>
            </div>
          </div>
        </div>

        <div>
          <p *ngIf="data.description" [innerHTML]="data.description | safe: 'html'"></p>

          <div class="row cc_dl">
            <ng-container *ngIf="data.description && data.contentLic">
              <ng-container *ngIf="data.contentLic === '僅限公開瀏覽'">
                <a href="javascript:void(0)" tabIndex="-1" role="button" title="{{'detailPage.dataAuthWithViewOnlynoDownload' | translate}}" style="cursor: default;" aria-disabled="true">
                  <img src="/assets/images/v040/ico-download-no.webp" class="cc_dl_img" alt="{{'nodownload' | translate}}"
                  width="28" height="35">
                </a>
              </ng-container>
              <ng-container *ngIf="data.contentLic !== '僅限公開瀏覽'">
                <div style="position: relative; display: inline-block;">
                  <a href="javascript:void(0)" tabIndex="0" role="button" title="{{'detailPage.downloadText'| translate}}-{{data.title}}" *ngIf="dwTooltip"
                  attr.aria-expanded="{{dwTooltip.isOpened ? 'true' : 'false'}}"
                  (click)="toggleDownloadTip()"
                  [tmCloseOnContainerBlur]="dwTooltip.hostEl"
                  [listenOnOpen]="listenOnDownloadTooltipOpen"
                  [listenOnClose]="listenOnDownloadTooltipClose"
                  [closeContainer]="closeDownloadTooltip"
                  #ccb="tmCCB">
                    <img src="/assets/images/v040/ico-download.webp" class="cc_dl_img" alt="{{'download' | translate}}"
                    width="32" height="31">
                  </a>
                  <a href="javascript:void(0)" tabIndex="0" role="button" title="{{'detailPage.downloadText'| translate}}-{{data.title}}" *ngIf="!dwTooltip">
                    <img src="/assets/images/v040/ico-download.webp" class="cc_dl_img" alt="{{'download' | translate}}"
                    width="32" height="31">
                  </a>
                  <app-download-tooltip *ngIf="authLicRef2"
                  [data]="data"
                  [fetchIndexCode]="fetchIndexCode"
                  [sharePageUrl]="sharePageUrl"
                  [authorityImg]="authLicRef2.image"
                  [authorityLink]="authLicRef2.url"
                  [authorityText]="authLicRef2.description"
                  #dwTooltip="downloadTooltip"></app-download-tooltip>
                </div>
              </ng-container>
              <a [appAuthLicense]="data.contentLic" #authLicRef2="appAuthLicense" [href]="authLicRef2.url || ('javascript:void(0)' | safe:'url')" [tabIndex]="authLicRef2.url ? 0 : -1"
              attr.role="{{authLicRef2.url ? 'link' : 'button'}}"  title="{{'detailPage.fieldLabel.contentLic' | translate}}: {{data.contentLic}}{{authLicRef2.url ? ('[' + 'openNewWindow' | translate) + ']' : ''}}" [target]="authLicRef2.url ? '_blank' : ''"
              [style.cursor]="authLicRef2.url ? '' : 'default'"
              attr.aria-disabled="{{!authLicRef2.url}}">
                <img src="{{authLicRef2.image || ''}}" class="cc_dl_img" alt="{{'detailPage.fieldLabel.contentLic' | translate}}: {{data.contentLic}}"
                width="{{authLicRef2.imageWidth}}" height="{{authLicRef2.imageHeight}}">
              </a>
            </ng-container>
          </div>

          <h3>{{'detailPage.basicInfo' | translate}}</h3>
          <div class="info">
            <div class="detail-field-row" *ngIf="data.linkPath">
              <span class="label">{{'detailPage.fieldLabel.linkPath' | translate}}</span><span class="label-cont"><a href="{{data.linkPath}}" target="_blank" title="{{'openNewWindow' | translate}}" class="btn btn-warning">{{'detailPage.fieldLabel.linkPath' | translate}}</a></span>
            </div>
            <div class="detail-field-row" *ngIf="data.sourceName">
              <span class="label">{{'detailPage.fieldLabel.sourceName' | translate}}</span><span class="label-cont">{{data.sourceName}}</span>
            </div>
            <div class="detail-field-row" *ngIf="data.uid">
              <span class="label">{{'detailPage.fieldLabel.uid' | translate}}</span><span class="label-cont">{{data.uid}}</span>
            </div>
            <div class="detail-field-row" *ngIf="data.subjects">
              <span class="label">{{'detailPage.fieldLabel.subjects' | translate}}</span><span class="label-cont">{{data.subjects}}</span>
            </div>
            <div class="detail-field-row" *ngIf="data.createDept">
              <span class="label">{{'detailPage.fieldLabel.createDept' | translate}}</span><span class="label-cont">{{data.createDept}}</span>
            </div>

            <div class="collapse" id="collapseContent" appBsCollapse #infoCollapseSt="bsCollapse">
              <ng-container *ngFor="let key of nonCommonFieldKeys">
                <!-- 多判斷是object , 但卻是空object, 不顯示 -->
                <div class="detail-field-row" *ngIf="isShowNonCommonField(data[key])">
                  <span class="label">{{('detailPage.fieldLabel.' + fetchIndexCode + '.' + key) | translate}}</span>
                  <div class="label-cont">
                    <ng-container *ngIf="fetchIndexCode === 'Culture_Media' && key === 'categories'">
                      <span>{{stringlizeCategories(data[key])}}</span>
                    </ng-container>
                    <ng-container *ngIf="(fetchIndexCode === 'Culture_Event' || fetchIndexCode === 'Culture_Object' || fetchIndexCode === 'Culture_Media') && key === 'contributors'">
                      <span [innerHtml]="stringlizeContributors(data[key]) | safe: 'html'"></span>
                    </ng-container>
                    <ng-container *ngIf="(fetchIndexCode === 'Culture_Object' || fetchIndexCode === 'Culture_Media') && key === 'dates'">
                      <span [innerHtml]="stringlizeDates(data[key]) | safe: 'html'"></span>
                    </ng-container>
                    <ng-container *ngIf="(fetchIndexCode === 'Culture_Object' || fetchIndexCode === 'Culture_Media') && key === 'places'">
                      <span [innerHtml]="stringlizePlaces(data[key]) | safe: 'html'"></span>
                    </ng-container>
                    <ng-container *ngIf="
                    !((fetchIndexCode === 'Culture_Event' || fetchIndexCode === 'Culture_Object' || fetchIndexCode === 'Culture_Media') && key === 'contributors')
                    && !(fetchIndexCode === 'Culture_Media' && key === 'categories')
                    && !((fetchIndexCode === 'Culture_Object' || fetchIndexCode === 'Culture_Media') && key === 'dates')
                    && !((fetchIndexCode === 'Culture_Object' || fetchIndexCode === 'Culture_Media') && key === 'places')">
                      <ng-container *ngTemplateOutlet="valTmp; context: {$implicit: data[key], key: key}"></ng-container>
                    </ng-container>
                  </div>

                  <ng-template #valTmp let-value ley-key="key">
                    <ng-container *ngIf="isString(value); else nonStringValTmp">
                      <ng-container *ngIf="isLink(value); else defaultStringValTmp">
                        <a href="{{value}}" target="_blank" title="{{('detailPage.fieldLabel.' + fetchIndexCode + '.' + key) | translate}}[{{'openNewWindow' | translate}}]">{{value}}</a>
                      </ng-container>
                    </ng-container>

                    <ng-template #nonStringValTmp>
                      <ng-container *ngIf="isObject(value); else defaultStringValTmp">
                        <ng-container *ngIf="isArray(value)">
                          <ng-container *ngIf="isStrArray(value); else objectArrayValTmp">
                            <span>{{value.join('/')}}</span>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!isArray(value)">
                          <ng-container *ngTemplateOutlet="objectValTmp; context: {$implicit: value}"></ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-template>

                    <ng-template #objectArrayValTmp>
                      <!-- 針對 BOCH 物件陣列顯示調整 -->
                      <ng-container *ngIf="key === 'landlots' || key === 'addresses' || key === 'caseOwnership' || key === 'announcements'; else notBochTmp">
                        <!-- 針對 BOCH 所有權屬 -->
                        <ng-container *ngIf="key === 'announcements'">
                          <div class="ng-star-inserted">
                            <div class="td_cont">
                              <div class="owner_title">
                                <div class="span125 wd-25">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.announcements_classification') | translate}} </div>
                                <div class="span125 wd-25">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.announcements_officialDocNo') | translate}}</div>
                                <div class="span125 wd-25">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.announcements_registerDate') | translate}} </div>
                                <div class="span125 wd-25">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.announcements_note') | translate}}</div>
                              </div>
                              <div id="loaddate">
                                <div class="owner" *ngFor="let item of value">
                                  <div class="span125 wd-25"><span [innerHTML]="item.classification | safe: 'html'"></span></div>
                                  <div class="span125 wd-25"><span [innerHTML]="item.officialDocNo | safe: 'html'"></span></div>
                                  <div class="span125 wd-25"><span [innerHTML]="item.registerDate | safe: 'html'"></span></div>
                                  <div class="span125 wd-25"><span [innerHTML]="item.note | safe: 'html'"></span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <!-- 針對 BOCH 所有權屬 -->
                        <ng-container *ngIf="key === 'caseOwnership'">
                          <div class="ng-star-inserted">
                            <div class="td_cont">
                              <div class="owner_title">
                                <div class="span125 wd-50">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.caseOwnership_ownerType') | translate}} </div>
                                <div class="span125 wd-50">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.caseOwnership_ownerName') | translate}}</div>

                              </div>
                              <div id="loaddate">
                                <div class="owner" *ngFor="let item of value">
                                  <div class="span125 wd-50"><span [innerHTML]="item.ownerType | safe: 'html'"></span></div>
                                  <div class="span125 wd-50"><span [innerHTML]="item.ownerName | safe: 'html'"></span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <!-- 針對 BOCH 現況地址 -->
                        <ng-container *ngIf="key === 'addresses'">
                          <div class="ng-star-inserted">
                            <div class="td_cont">
                              <div class="owner_title">
                                <div class="span125 wd-25">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.landlots_itemNo') | translate}} </div>
                                <div class="span125 wd-25">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.landlots_cityName') | translate}}</div>
                                <div class="span125 wd-25">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.landlots_distName') | translate}} </div>
                                <div class="span125 wd-25">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.addresses_address') | translate}}</div>
                              </div>
                              <div id="loaddate">
                                <div class="owner" *ngFor="let item of value">
                                  <div class="span125 wd-25"><span [innerHTML]="item.itemNo | safe: 'html'"></span></div>
                                  <div class="span125 wd-25"><span [innerHTML]="item.cityName | safe: 'html'"></span></div>
                                  <div class="span125 wd-25"><span [innerHTML]="item.distName | safe: 'html'"></span></div>
                                  <div class="span125 wd-25"><span [innerHTML]="item.address | safe: 'html'"></span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <!-- 針對 BOCH 定著土地範圍(公告地號) -->
                        <ng-container *ngIf="key === 'landlots'">
                          <div class="ng-star-inserted">
                            <div class="td_cont">
                              <div class="owner_title">
                                <div class="span125 wd-20">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.landlots_itemNo') | translate}} </div>
                                <div class="span125 wd-20">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.landlots_cityName') | translate}}</div>
                                <div class="span125 wd-20">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.landlots_distName') | translate}} </div>
                                <div class="span125 wd-20">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.landlots_landNo') | translate}}</div>
                                <div class="span125 wd-20">{{('detailPage.fieldLabel.BOCH_CountryCulture_31.landlots_landSerialNo') | translate}}</div>
                              </div>
                              <div id="loaddate">
                                <div class="owner" *ngFor="let item of value">
                                  <div class="span125 wd-20"><span [innerHTML]="item.itemNo | safe: 'html'"></span></div>
                                  <div class="span125 wd-20"><span [innerHTML]="item.cityName | safe: 'html'"></span></div>
                                  <div class="span125 wd-20"><span [innerHTML]="item.distName | safe: 'html'"></span></div>
                                  <div class="span125 wd-20"><span [innerHTML]="item.landNo | safe: 'html'"></span></div>
                                  <div class="span125 wd-20"><span [innerHTML]="item.landSerialNo | safe: 'html'"></span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                      <ng-template #notBochTmp>
                        <ng-container *ngFor="let item of value">
                          <ng-container *ngTemplateOutlet="valTmp; context: {$implicit: item, key: key}"></ng-container>
                        </ng-container>
                      </ng-template>
                    </ng-template>

                    <ng-template #objectValTmp let-value>
                      <ng-container *ngFor="let okey of getObjKeys(value)">
                        <ng-container *ngIf="value[okey]">
                          <div class="label"><span>{{('detailPage.fieldLabel.' + fetchIndexCode + '.' + key + '_' + okey) | translate}}</span></div>
                          <div class="label-cont">
                            <ng-container *ngTemplateOutlet="valTmp; context: {$implicit: value[okey], key: okey}"></ng-container>
                          </div>
                          <br><br>
                        </ng-container>
                      </ng-container>
                    </ng-template>

                    <ng-template #defaultStringValTmp>
                      <span [innerHTML]="value | safe: 'html'"></span>
                    </ng-template>
                  </ng-template>
                </div>
              </ng-container>
            </div>
          </div>

          <button class="more_btn" attr.aria-expanded="{{infoCollapseSt.isShow}}" aria-controls="collapseContent" (click)="infoCollapseSt.toggle()">
            {{'detailPage.' + (infoCollapseSt.isShow ? 'collapseAllContext' : 'expendAllContext') | translate}} <i class="fa fa-angle-{{infoCollapseSt.isShow ? 'up' : 'down'}}" aria-hidden="true" style="color: #eeba16;"></i>
          </button>

          <ng-container *ngIf="data.keywords && data.keywords.length">
            <h3>{{'detailPage.fieldLabel.keywords' | translate}}</h3>
            <label for="keywords" id="keywordsLabel" (click)="keywordsList.focus()" class="sr-only">{{'detailPage.fieldLabel.keywords' | translate}}</label>
            <ul id="keywords" aria-labelledby="keywordsLabel" role="listbox" tabindex="-1" #keywordsList>
              <ng-container *ngFor="let keyword of data.keywords">
                <a routerLink="{{toHomePath}}/datasearch" [queryParams]="{keyword: keyword}" queryParamsHandling="merge" target="_blank" title="{{'search' | translate}}{{keyword}}[{{'openNewWindow' | translate}}]"><li>#{{keyword}}</li></a>
              </ng-container>
            </ul>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
  <!-- /.區塊:1 -->

  <!-- 區塊:2 -->
  <section class="row clearfix print-exclude" *ngIf="messages">
    <div class="col-lg-10 col-lg-offset-1 col-md-12">
      <div class="search_01">
        <h3>{{messages.length}}{{'detailPage.numsMessageLeft' | translate}}</h3>

        <div class="row feedback">
          <div class="photo">
            <div class="circle01LG">
              <div class="image-wrap embed-responsive embed-responsive-1by1">
                <img src="/assets/images/user-default.webp" class="embed-responsive-item" alt="{{'detailPage.commentersHeadshot' | translate}}"
                *ngIf="!memberInfo"
                width="80" height="80"
                tmObjectFit="contain" imgSrc="/assets/images/user-default.webp"
                tmErrorDefaultImage="/assets/images/no-pic.webp">

                <div class="people-name embed-responsive-item" [style.background-color]="memberInfo['headColor']"
                *ngIf="memberInfo"
                attr.aria-label="{{('detailPage.someonesHeadshot' | translate:{who: memberInfo.name})}}">{{memberInfo.name | slice: 0:1}}</div>
              </div>
            </div>
          </div>
          <div class="word">
            <textarea placeholder="{{memberInfo ? ('detailPage.leveMesage' | translate) : ('detailPage.loginToLeaveMessage' | translate)}}" rows="2"
            attr.aria-label="{{'detailPage.comments' | translate}}"
            [disabled]="false" #commentEl></textarea>
          </div>
        </div>

        <div class="row m-n bot">
          <div class="btn-group">
            <button type="button" class="gray_btn" [disabled]="!commentEl.value">{{'detailPage.cancel' | translate}}</button>
            <button type="button" class="yellow_btn" [disabled]="!commentEl.value" (click)="leftComment(commentEl)">{{'detailPage.leveMesage2' | translate}}</button>
          </div>
        </div>

        <div class="row m-h-md feedback" *ngFor="let item of messages">
          <div class="photo">
            <div class="circle01SM">
              <div class="image-wrap embed-responsive embed-responsive-1by1">
                <!-- <img src="/assets/images/v040/ex_11.webp" class="embed-responsive-item"
                width="80" height="80"
                tmObjectFit="cover" imgSrc="/assets/images/v040/ex_11.webp"
                tmErrorDefaultImage="/assets/images/no-pic.webp"> -->
                <div class="people-name embed-responsive-item" [style.background-color]="item['headColor']"
                attr.aria-label="{{('detailPage.someonesHeadshot' | translate:{who: item.name})}}">{{item.name | slice: 0:1}}</div>
              </div>
            </div>
          </div>

          <div class="name">
            <h5 class="strong">{{item.name}}</h5>
            <time datetime="2021-05">{{ 'detailPage.yearMonth' | translate: ({year: item.createDate | date: 'yyyy', month: item.createDate | date: 'MM'}) }}</time>
          </div>

          <div class="cont circle01SMTXT">
            <p style="white-space: pre-line;">{{item.message}}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /.區塊:2 -->

  <!-- 區塊:3 -->
  <section class="row clearfix print-exclude" *ngIf="otherRadomDatas" [style.height]="isBrowser ? '' : '650px'">
    <div class="col-lg-10 col-lg-offset-1 col-md-12" *ngIf="isBrowser">
      <div class="portfolio_59">
        <h2 style="padding-bottom: 30px;">{{'detailPage.otherDataBySameKeyword' | translate: ({keyword: usedKeyword})}}</h2>
        <div class="swiper" [tmSwiper]="swiperConfig" #swiper1="tmSwiper">
          <div class="swiper-button-prev" role="button"
          (click)="swiper1.slidePrev()" (keydown.enter)="swiper1.slidePrev()"
          [class.swiper-button-disabled]="swiper1.activeIndex === 0 || otherRadomDatas.length <= swiper1.viewItemCount"
          [attr.aria-disabled]="swiper1.activeIndex === 0 || otherRadomDatas.length <= swiper1.viewItemCount"
          [attr.aria-label]="'swiper.prevSlideMessage' | translate"
          [tabindex]="swiper1.activeIndex === 0 || otherRadomDatas.length <= swiper1.viewItemCount ? -1 : 0"
          ></div>
          <div class="swiper-wrapper">
            <div class="swiper-slide swiper-slide-1 swiper-slide-sm-2 swiper-slide-md-4" *ngFor="let rd of otherRadomDatas; index as i">
              <div class="aside-box clearfix">
                <a title="{{rd.materialName}}[{{'openNewWindow' | translate}}]"
                routerLink="{{toHomePath}}/detail" [queryParams]="{indexCode: rd.fetchIndex, id: rd.materialId}"  target="_blank"
                [tabindex]="i >= swiper1.activeIndex && i < swiper1.activeIndex + swiper1.viewItemCount? 0 : -1"
                appLogHitCount [logLock]="lock" appLock #lock="lock">
                  <ng-container *ngIf="rd.iframeUrl; else elseTemplateImgViewMode1">
                    <div class="image-wrap embed-responsive embed-responsive-1by1">
                      <div class="embed-responsive-item" style="background-color: #eeeeee;">
                        <div class="embed-responsive embed-responsive-16by9" style="top: 50%; transform: translateY(-50%);">
                          <div class="embed-responsive-item" #containerRef>
                            <ng-container *ngIf="rd.iframeUrl.endsWith('.m3u8'); else commonVideoTmp">
                              <iframe
                              title="{{rd.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                              [src]="$any(('/assets/hls-video-player?url=' + (rd.iframeUrl | base64) + '&width=' + containerRef.offsetWidth + '&height=' + containerRef.offsetHeight) | safe: 'resource')"
                              [width]="containerRef.offsetWidth" [height]="containerRef.offsetHeight"
                              frameborder="0" allowfullscreen scrolling="no"
                              ></iframe>
                            </ng-container>
                            <ng-template #commonVideoTmp>
                              <iframe
                              [src]="$any(rd.iframeUrl | safe: 'resource')" title="{{rd.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                              width="400" height="400" frameborder="0" allowfullscreen scrolling="no"
                              ></iframe>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #elseTemplateImgViewMode1>
                    <ng-container *ngTemplateOutlet="imgViewTmp; context: {$implicit: (apiHost + '/api/collection/image/' + rd.fetchIndex + '?uid=' + rd.materialId), defaultImageUrl: '/assets/images/no-pic.webp'}"></ng-container>
                  </ng-template>
                  <ng-template #imgViewTmp let-imgSrc let-defaultImageUrl="defaultImageUrl">
                    <div class="image-wrap embed-responsive embed-responsive-1by1">
                      <div class="small-img-background" [style.background-image]="rd['imageNaturalHeight'] && (rd['imageNaturalWidth'] < 300 || rd['imageNaturalHeight'] < 300) ? ('url(' + apiHost + '/api/collection/image/' + rd.fetchIndex + '?uid=' + rd.materialId + ')') : ''"></div>
                      <img class="embed-responsive-item fit_cover" *ngIf="i < 4"
                      src="{{imgSrc}}" alt=""
                      width="400" height="400"
                      [tmObjectFit]="!imgRef || imgRef && imgRef.naturalHeight >= 300 ? 'cover' : 'scale-down'" [imgSrc]="imgSrc"
                      [tmErrorDefaultImage]="defaultImageUrl"
                      lazyLoading
                      (load)="onMaterialImageSrcLoad(rd, imgRef)"
                      #imgRef>
                      <ng-container *ngIf="i >= 4">
                        <ng-container *ngIf="isSupportObjectFit">
                          <img class="embed-responsive-item fit_cover swiper-lazy"
                          attr.data-src="{{imgSrc}}"
                          src="" alt=""
                          width="400" height="400"
                          [tmObjectFit]="!imgRef || imgRef && imgRef.naturalHeight >= 300 ? 'cover' : 'scale-down'"
                          [tmErrorDefaultImage]="defaultImageUrl"
                          (load)="onMaterialImageSrcLoad(rd, imgRef)"
                          #imgRef>
                          <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                        </ng-container>
                        <ng-container *ngIf="!isSupportObjectFit">
                          <div attr.data-background="{{rd.imageUrl ? imgSrc : defaultImageUrl}}"
                          class="embed-responsive-item swiper-lazy"
                          [style.background-image]="'url(' + defaultImageUrl + ')'">
                            <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-template>
                  <div class="details">
                    <h3 class="title text-overflow" *ngIf="rd.materialName">{{rd.materialName}}</h3>
                  </div>
                </a>
                <div class="t-mark-t5-r20">
                  <theme-collect-btn type="collection" [materialId]="rd.materialId" [fetchIndex]="rd.fetchIndex"
                  [disabled]="i < swiper1.activeIndex || i >= swiper1.activeIndex + swiper1.viewItemCount" [title]="rd.materialName"></theme-collect-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next" role="button"
          (click)="swiper1.slideNext()" (keydown.enter)="swiper1.slideNext()"
          [class.swiper-button-disabled]="swiper1.activeIndex === otherRadomDatas.length - swiper1.viewItemCount || otherRadomDatas.length <= swiper1.viewItemCount"
          [attr.aria-disabled]="swiper1.activeIndex === otherRadomDatas.length - swiper1.viewItemCount || otherRadomDatas.length <= swiper1.viewItemCount"
          [attr.aria-label]="'swiper.nextSlideMessage' | translate"
          [tabindex]="swiper1.activeIndex === otherRadomDatas.length - swiper1.viewItemCount || otherRadomDatas.length <= swiper1.viewItemCount ? -1 : 0"
          ></div>
        </div>
      </div>
    </div>
  </section>
  <!-- /.區塊:3 -->

  <!-- 區塊:4 -->
  <section class="row clearfix print-exclude" *ngIf="data.relevant && data.relevant.length" [style.height]="isBrowser ? '' : '650px'">
    <div class="col-lg-10 col-lg-offset-1 col-md-12" *ngIf="isBrowser">
      <div class="portfolio_59">
        <h2 style="padding-bottom: 30px;" *ngIf="data.createDept">{{'detailPage.moreData2' | translate: ({createDept: data.createDept}) }}</h2>
        <h2 style="padding-bottom: 30px;" *ngIf="!data.createDept">{{'detailPage.moreData' | translate}}</h2>
        <div class="swiper" [tmSwiper]="swiperConfig" #swiper2="tmSwiper">
          <div class="swiper-button-prev" role="button"
          (click)="swiper2.slidePrev()" (keydown.enter)="swiper2.slidePrev()"
          [class.swiper-button-disabled]="swiper2.activeIndex === 0 || data.relevant.length <= swiper2.viewItemCount"
          [attr.aria-disabled]="swiper2.activeIndex === 0 || data.relevant.length <= swiper2.viewItemCount"
          [attr.aria-label]="'swiper.prevSlideMessage' | translate"
          [tabindex]="swiper2.activeIndex === 0 || data.relevant.length <= swiper2.viewItemCount ? -1 : 0"
          ></div>
          <div class="swiper-wrapper">
            <div class="swiper-slide swiper-slide-1 swiper-slide-sm-2 swiper-slide-md-4" *ngFor="let rd of data.relevant; index as i">
              <div class="aside-box clearfix">
                <a title="{{rd.materialName}}[{{'openNewWindow' | translate}}]"
                routerLink="{{toHomePath}}/detail" [queryParams]="{indexCode: rd.fetchIndex, id: rd.materialId}" target="_blank"
                [tabindex]="i >= swiper2.activeIndex && i < swiper2.activeIndex + swiper2.viewItemCount? 0 : -1"
                appLogHitCount [logLock]="lock" appLock #lock="lock">
                  <ng-container *ngIf="rd.iframeUrl; else elseTemplateImgViewMode1">
                    <div class="image-wrap embed-responsive embed-responsive-1by1">
                      <div class="embed-responsive-item" style="background-color: #eeeeee;">
                        <div class="embed-responsive embed-responsive-16by9" style="top: 50%; transform: translateY(-50%);">
                          <div class="embed-responsive-item" #containerRef>
                            <ng-container *ngIf="rd.iframeUrl.endsWith('.m3u8'); else commonVideoTmp">
                              <iframe
                              title="{{rd.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                              [src]="$any(('/assets/hls-video-player?url=' + (rd.iframeUrl | base64) + '&width=' + containerRef.offsetWidth + '&height=' + containerRef.offsetHeight) | safe: 'resource')"
                              [width]="containerRef.offsetWidth" [height]="containerRef.offsetHeight"
                              frameborder="0" allowfullscreen scrolling="no"
                              ></iframe>
                            </ng-container>
                            <ng-template #commonVideoTmp>
                              <iframe
                              [src]="$any(rd.iframeUrl | safe: 'resource')" title="{{rd.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                              width="400" height="400" frameborder="0" allowfullscreen scrolling="no"
                              ></iframe>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #elseTemplateImgViewMode1>
                    <ng-container *ngTemplateOutlet="imgViewTmp; context: {$implicit: (apiHost + '/api/collection/image/' + rd.fetchIndex + '?uid=' + rd.materialId), defaultImageUrl: '/assets/images/no-pic.webp'}"></ng-container>
                  </ng-template>
                  <ng-template #imgViewTmp let-imgSrc let-defaultImageUrl="defaultImageUrl">
                    <div class="image-wrap embed-responsive embed-responsive-1by1">
                      <div class="small-img-background" [style.background-image]="rd['imageNaturalHeight'] && (rd['imageNaturalWidth'] < 300 || rd['imageNaturalHeight'] < 300) ? ('url(' + apiHost + '/api/collection/image/' + rd.fetchIndex + '?uid=' + rd.materialId + ')') : ''"></div>
                      <img class="embed-responsive-item fit_cover" *ngIf="i < 4"
                      src="{{imgSrc}}" alt=""
                      width="400" height="400"
                      [tmObjectFit]="!imgRef || imgRef && (imgRef.naturalWidth >= 300 && imgRef.naturalHeight >= 300) ? 'cover' : 'scale-down'" [imgSrc]="imgSrc"
                      [tmErrorDefaultImage]="defaultImageUrl"
                      lazyLoading
                      (load)="onMaterialImageSrcLoad(rd, imgRef)"
                      #imgRef>
                      <ng-container *ngIf="i >= 4">
                        <ng-container *ngIf="isSupportObjectFit">
                          <img class="embed-responsive-item fit_cover swiper-lazy"
                          attr.data-src="{{imgSrc}}"
                          src="" alt=""
                          width="400" height="400"
                          [tmObjectFit]="!imgRef || imgRef && (imgRef.naturalWidth >= 300 && imgRef.naturalHeight >= 300) ? 'cover' : 'scale-down'"
                          [tmErrorDefaultImage]="defaultImageUrl"
                          (load)="onMaterialImageSrcLoad(rd, imgRef)"
                          #imgRef>
                          <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                        </ng-container>
                        <ng-container *ngIf="!isSupportObjectFit">
                          <div attr.data-background="{{rd.imageUrl ? imgSrc : defaultImageUrl}}"
                          class="embed-responsive-item swiper-lazy"
                          [style.background-image]="'url(' + defaultImageUrl + ')'">
                            <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-template>
                  <div class="details">
                    <h3 class="title text-overflow" *ngIf="rd.materialName">{{rd.materialName}}</h3>
                  </div>
                </a>
                <div class="t-mark-t5-r20">
                  <theme-collect-btn type="collection" [materialId]="rd.materialId" [fetchIndex]="rd.fetchIndex"
                  [disabled]="i < swiper2.activeIndex || i >= swiper2.activeIndex + swiper2.viewItemCount" [title]="rd.materialName"></theme-collect-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next" role="button"
          (click)="swiper2.slideNext()" (keydown.enter)="swiper2.slideNext()"
          [class.swiper-button-disabled]="swiper2.activeIndex === data.relevant.length - swiper2.viewItemCount || data.relevant.length <= swiper2.viewItemCount"
          [attr.aria-disabled]="swiper2.activeIndex === data.relevant.length - swiper2.viewItemCount || data.relevant.length <= swiper2.viewItemCount"
          [attr.aria-label]="'swiper.nextSlideMessage' | translate"
          [tabindex]="swiper2.activeIndex === data.relevant.length - swiper2.viewItemCount || data.relevant.length <= swiper2.viewItemCount ? -1 : 0"
          ></div>
        </div>
      </div>
    </div>
  </section>
  <!-- /.區塊:4 -->
</ng-container>

<app-share-social-modal #shareToolModal></app-share-social-modal>

<ng-template #downloadToolTipTmp let-downloadData let-downloadRightsCitation="downloadRightsCitation" let-copyCitation="fn.copyCitation">
  <div *ngIf="photoSwipeCmp.canDownload" class="tm_pswp-download">
    <a class="download-btn btn" title="{{ downloadData.title }}[{{'openNewWindow' | translate}}]" target="_blank" href="{{ downloadData.src }}">
      <span class="label">下載檔案</span>
      <span class="format"><div>{{ downloadData.w }} x {{ downloadData.h }} 像素 {{ downloadData.fileExt }}</div></span>
    </a>
  </div>
  <div class="tm_pswp-info">
    <div class="tm_pswp-usage-info">
      <!-- 版權提示  -->
      <div *ngIf="downloadData.imageAuthorityImg || !downloadData.imageAuthorityUrl" class="tm_pswp-rights-tip">
        {{ downloadData.imageAuthorityText }}
        <!-- ICON  -->
        <a *ngIf="downloadData.imageAuthorityImg" href="{{ downloadData.imageAuthorityUrl }}" target="_blank" class="tm_pswp-copyright copyright-link" title="{{ downloadData.imageAuthorityText }}[{{'openNewWindow' | translate}}]">
          <img src="{{ downloadData.imageAuthorityImg }}" alt="{{ downloadData.imageAuthorityText }}">
        </a>
      </div>
      <div *ngIf="!downloadData.imageAuthorityImg && downloadData.imageAuthorityUrl" class="tm_pswp-rights-tip">
        <a href="{{ downloadData.imageAuthorityUrl }}" target="_blank" class="copyright-link" title="{{ downloadData.imageAuthorityText }}[{{'openNewWindow' | translate}}]">
          {{ downloadData.imageAuthorityText }}
        </a>
      </div>
      <div *ngIf="photoSwipeCmp.canDownload" class="tm_pswp-cite-tip" (click)="photoSwipeCmp.copyCitation()"><i class="fa fa-clone" aria-hidden="true"></i>&nbsp;複製授權引用資訊</div>
      <!-- 引用文字  -->
      <div *ngIf="photoSwipeCmp.canDownload" class="tm_pswp-rights-citation" id="tm_pswp-rights-citation">{{photoSwipeCmp.downloadRightsCitation}}</div>
    </div>
  </div>
</ng-template>

<tm-photo-swipe *ngIf="isBrowser && data && data.downloadImages && data.imageLic && data.imageLic !== '僅限公開瀏覽'"
[downloadRightsCitationFormatter]="downloadRightsCitationFormatter"
[downloadToolTipTmp]="downloadToolTipTmp"
></tm-photo-swipe>
